import { HORIZONTAL_ELLIPSIS } from '@ardoq/global-consts';

/**
 * One break character and nothing else names nothing. `wrapString` hyphenates a word wider than
 * the line, so a shape a couple of characters across comes back as `B-` over `i-`.
 */
const isLegible = (line: string): boolean =>
  line.replace(HORIZONTAL_ELLIPSIS, '').replace(/-$/, '').length > 0;

/** A wrapped name is worth drawing whole or not at all — half of one is not a shorter name. */
export const legibleLines = (lines: string[]): string[] =>
  lines.length > 0 && lines.every(isLegible) ? lines : [];
